/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import { Button, CircularProgress, Collapse, IconButton, Paper, Slider, Table, TableBody, TableCell, TableContainer, TableHead, FormControl, FormControlLabel, FormLabel, 
    RadioGroup, Radio, TableRow, Typography, ButtonGroup, Tabs, Tab, Dialog, DialogActions, DialogContent, TextField, DialogTitle, Chip, Tooltip } from '@material-ui/core'

import { format } from 'date-fns'

import Actions from '../../fluid/Actions/ActionFactory'

import TrainingStage from '../IC/components/Operation/TrainingStage';
import Report from './Report/Report'
import { Clear, CheckCircleOutline, ErrorOutline, ArrowBack, Refresh } from '@material-ui/icons';


const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);
  
const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#40a9ff',
      },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    headerStyle : {
        color : '#707070',
        backgroundColor : 'rgba(245,245,245,0)',
        fontSize : 11,
        border : 'none'
    }
})

class IRC extends Component {
    state = {
        loading_data : false,
        loading_data_error : false,
        loading_data_error_message : null,
        all_ics : [],
        models : [],
        selectedRowIndex : null,
        drl_url : null,
        selected_ic : null,
        global_field_display_name : null,
        group_display_name : null,
        field_display_name : null,
        open_generate_group_params : false,
        generating_groups : false,
        generating_groups_error : false,
        generating_groups_error_message : "",
        loading_versions : false,
        loading_versions_error : false,
        versions : null,
        report_version : 1,
        loading_steps : false,
        loading_steps_error : false,
        steps : null,
        step_tag : null,
        show_report : false,
        global_schema_IU : null,
        clustering_threshold : 0,
        value_weight : 0,
        historical_mappings : null,
        use_conflict_scores : true,
        right_tab_index : 0,
        open_export_request_dialog : false,
        initiating_export_request : false,
        export_request_success : false,
        export_request_error : false,
        export_requests : null,
        loading_export_request : false,
        export_version : 0,
        export_version_groups : 0,
        export_version_type : 'range',
        export_version_format : 'html',
        export_ranges : [],
        export_subset_size : 0,
        range_start_index : 0,
        range_end_index : 0,
        range_index_error : false,
    }

    componentDidMount () {
        Actions('http_request', {
            url : "/sainapse/data_rendering_service",
            method : 'get',
            data : {}
        }).then(res => {
            this.setState({...this.state, drl_url : res.data.result[0].url}, () => this.getIRCICs())
        })
    }

    getIRCICs = () => {
        this.setState({...this.state, loading_data : true}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let all_ics = res.data.result
                let dedup_ics = all_ics.filter(ic => ic.operations.includes("IRC"))
                this.setState({...this.state, all_ics : all_ics,  loading_data : false, models : dedup_ics, loading_data_error : false, loading_data_error_message : null}, () => console.log("Dedup State :", this.state))
            }).catch(err => {
                this.setState({...this.state, all_ics : [],  loading_data : false, loading_data_error : true, loading_data_error_message : "Error in getting Dedup ICs."})
            })
        })
    }

    mergeRanges = () => {
        let ranges = this.state.export_ranges
        let mergedRanges = []
        if (ranges.length > 1) {
            ranges.sort((a, b) => a.start_index - b.start_index);
            let previous = ranges[0];
            for (let i = 1; i < ranges.length; i += 1) {
                if (previous.end_index >= ranges[i].start_index) {
                    previous.end_index = Math.max(previous.end_index, ranges[i].end_index)
                } else {
                    mergedRanges.push(previous);
                    previous = ranges[i];
                }
            }  
            mergedRanges.push(previous);
            this.setState({...this.state, export_ranges : mergedRanges})
        }
    }

    renderReport = () => {
        if (this.state.report_ic_name !== null && this.state.report_version !== null) {
            if (this.state.show_report) {
                return (
                    <Report 
                        ic_name = {this.state.selected_ic} 
                        version = {this.state.report_version}
                        step_tag = {this.state.step_tag}
                        search_columns = {this.state.search_columns}
                        global_field_display_name = {this.state.global_field_display_name}
                        group_display_name = {this.state.group_display_name}
                        field_display_name = {this.state.field_display_name}
                        close_report = {this.closeReport} 
                        close_n_complete = {(ic_name, version) => {
                            this.setState({...this.state, show_report : false, report_version : null}, () => {
                            this.completeReview(ic_name, version)
                        })
                    }}/>
                )
            }
        }
    }

    closeReport = () => {
        this.setState({...this.state, show_report : false, report_version : null})
    }

    renderIRCs = () => {
        return (
            <div style = {{width  : '100%', height : 'calc(100vh - 50px)'}}>
                <Paper variant = 'outlined' square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{fontSize : 20, fontWeight : 600}} variant = 'h6'>Intelligent Row Consolidation</Typography>
                </Paper>
                <div style = {{width : '100%', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row'}}>
                    <div style = {{width : '30%', height : '100%'}}>
                        {this.state.loading_data ? 
                        <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <CircularProgress variant = 'determinate' color = 'primary'/>
                        </div> : this.renderICs()}
                    </div>
                    <div style = {{width : '70%', height : '100%'}}>
                        {this.state.selected_ic !== null ? this.state.step_tag !== null ? this.renderIRCDetails() : this.renderSteps() : null}
                    </div>
                </div>
            </div>
        );
    }

    renderSteps = () => {
        //if(this.state.steps !==null && this.state.step_tag === null) {
            return(
                <div style={{ width: '100%', height: '100%'}}>
                    <Paper square elevation = {0} style = {{width : '100%', height : '50px', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>IRC Report Steps</Typography>
                    </Paper>
                    {
                        (this.state.loading_steps) && <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <CircularProgress variant = 'indeterminate' color = 'primary'/>
                        </div>
                    }
                    { !this.state.loading_steps && this.state.steps !== null && this.state.step_tag === null && <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Order ID</TableCell>
                                        <TableCell>Step</TableCell>
                                        <TableCell>Created On</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.steps.map((step) => {
                                        return(
                                            <TableRow
                                                style={{width : '100%', backgroundColor : this.state.step_tag === step.step_tag ? '#EBF7FF' : '#FFFFFF', cursor : 'pointer'}}
                                                onClick = {() => this.setState({...this.state, step_tag: step.step_tag}, () => this.getVersions())}
                                            >
                                                <TableCell>{step.order_id}</TableCell>
                                                <TableCell>{step.step_tag}</TableCell>
                                                <TableCell>{format(new Date(step.creation_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx")}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>}
                </div>
            )
        //}
    }

    renderIRCDetails = () => {
        return (
            <div style = {{width : '100%', height : '100%'}}>
                {this.renderTabs()}
                {this.renderTabContent()}
            </div>
        )
    }

    renderTabs = () => {
        return (
            <div style = {{width : '100%',height: '50px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '10%', height: '50px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
                    <IconButton size = 'small' onClick={() => this.setState({...this.state, step_tag: null, versions: null, right_tab_index: 0})}>
                        <ArrowBack fontSize='inherit'/>
                    </IconButton>
                    <Typography variant='subtitle2' style={{ marginLeft: '5px', flexGrow: 1}}>Step: {this.state.step_tag}</Typography>
                </div>
                <div style={{width: '90%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    <AntTabs
                        style={{ flexGrow: 1}}
                        value={this.state.right_tab_index}
                        indicatorColor="primary"
                        textColor="primary"
                        variant = 'scrollable'
                        scrollButtons="auto"
                        onChange = {(event, newValue) => this.setState({...this.state, right_tab_index : newValue, export_requests : null, loading_export_request : false})}
                    >
                        <AntTab label = 'Versions'/>
                        <AntTab label = 'Exports' />
                    </AntTabs>
                </div>
            </div>
        )
    }

    renderTabContent = () => {
        if (this.state.right_tab_index === 0) {
            return this.renderVersions()
        } else {
            return this.renderExports()
        }
    }

    renderICs = () => {
        const { classes } = this.props
        return (
            <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography variant = 'subtitle2'>Information Channels</Typography>
                </Paper>
                <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                    <TableContainer
                        style = {{
                            width : '100%',
                            maxHeight : '100%'
                        }}
                    >
                        <Table
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        // className = {classes.headerStyle}
                                    >Name</TableCell>
                                    <TableCell
                                        // className = {classes.headerStyle}
                                    >Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.models.map(model => {
                                    console.log('IRC :: Models :', model)
                                    let search_columns = model.world_view.fields.map(field => field.name)
                                    return (
                                        <TableRow 
                                            style = {{width : '100%', backgroundColor : this.state.selected_ic === model.name ? '#EBF7FF' : '#FFFFFF', cursor : 'pointer'}}
                                            onClick = {() => {
                                                let global_field_display_name = model.world_view.configs.find(config => config.operation === "IRC").config_params.global_record_identifier
                                                let group_display_name = "Group"
                                                let field_display_name = "Record"

                                                this.setState(
                                                    {
                                                        ...this.state, 
                                                        selected_ic : this.state.selected_ic === model.name ? null : model.name,
                                                        step_tag : null,
                                                        steps : null,
                                                        global_field_display_name : global_field_display_name,
                                                        group_display_name : group_display_name,
                                                        field_display_name : field_display_name,
                                                        search_columns : search_columns,
                                                        right_tab_index : 0,
                                                        generating_groups_error : false,
                                                        generating_groups_error_message : ""
                                                    }, () => this.getSteps())
                                                }}
                                        >
                                            <TableCell>{model.name}</TableCell>
                                            <TableCell>{this.renderDedupOperationStatus(model)}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        )
    }

    getSteps = () => {
        if (this.state.selected_ic !== null) {
            console.log("IRC :: Global Field Display Name : ", this.state.global_field_display_name)
            this.setState({...this.state, loading_steps : true, loading_steps_error : false}, () => {
                Actions('http_request', {
                    url : "/sainapse/irc/step_info",
                    method : "post",
                    data : {
                        ic_name : this.state.selected_ic
                    }
                }).then(res => {
                    console.log("irc :: Report Steps : ", res.data.result)
                    let steps = res.data.result.Result
                    steps.sort((a,b) => a.order_id - b.order_id)
                    this.setState({...this.state, loading_steps : false, loading_steps_error : false, steps: steps})
                }).catch(err => {
                    this.setState({...this.state, loading_steps : false, loading_steps_error : true, steps: null})
                })
            })
        }
    }

    getVersions = () => {
        if (this.state.selected_ic !== null && this.state.step_tag !== null) {
            console.log("IRC :: Global Field Display Name : ", this.state.global_field_display_name)
            this.setState({...this.state, loading_versions : true, loading_versions_error : false}, () => {
                Actions('http_request', {
                    url : "/sainapse/irc/version_info",
                    method : "post",
                    data : {
                        ic_name : this.state.selected_ic,
                        step_tag : this.state.step_tag
                    }
                }).then(res => {
                    console.log("irc :: Report Versions : ", res.data.result)
                    let report_status_objects = res.data.result.Result.map(ver => {
                        return {
                            url : this.state.drl_url + '/drl/irc/report/status',
                            method : 'get',
                            data : {},
                            params : {
                                ic_name : this.state.selected_ic,
                                report_version : ver.version
                            }
                        }
                    })
                    // Actions('http_requests', report_status_objects).then(res => {
                    //     console.log('IRC Version Report Status : ', res.data.result)
                    // })
                    this.setState({...this.state, loading_versions : false, loading_versions_error : false, versions: res.data.result.Result})
                }).catch(err => {
                    this.setState({...this.state, loading_versions : false, loading_versions_error : true, versions: null})
                })
            })
        }
    }

    renderDedupOperationStatus = (ic_data) => {
        let ic_op = ic_data.operations.filter(op => op === "IRC")
        let operation = ic_op.map(op =>  <TrainingStage size = 'small' ic = {ic_data} op = {op} step_tag = {this.state.step_tag} refresh = {this.getDedupeICs} interaction = {false}/>)
        console.log('IC OP :', operation)
        return operation
    }


    renderExports = () => {
        if (this.state.export_requests === null && this.state.loading_export_request === false) {
            this.setState({...this.state, loading_export_request : true}, () => {
                Actions('http_request', {
                    url : this.state.drl_url + '/drl/irc/report/status',
                    method : 'get',
                    data : {},
                    params : {
                        ic_name : this.state.selected_ic
                    }
                }).then(res => {
                    console.log('Export Requests : ', res.data)
                    let sorted_export_request = res.data.sort((a, b) => new Date(b.requested_time) - new Date(a.requested_time))
                    this.setState({...this.state, loading_export_request : false, export_requests : sorted_export_request})
                }).catch(err => {

                })
            })
        }

        return (
            <TableContainer style = {{maxHeight : '100%' , overflow : 'auto'}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                sortDirection = 'desc'
                            >Requested Time</TableCell>
                            <TableCell>Information Channel</TableCell>
                            <TableCell>Source Version</TableCell>
                            <TableCell>Format</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Download</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.export_requests && this.state.export_requests.map(request => {
                            return (
                                <TableRow>
                                    <TableCell>{new Date(request.requested_time).toString()}</TableCell>
                                    <TableCell>{request.ic_name}</TableCell>
                                    <TableCell>{request.report_version}</TableCell>
                                    <TableCell>{request.report_format}</TableCell>
                                    <TableCell>{request.status}</TableCell>
                                    <TableCell>
                                        <Button
                                            size = 'small'
                                            color = 'primary'
                                            disabled = {request.status !== 'Completed'}
                                            onClick = {() => this.downloadReport(request.file_name)}
                                        >Download</Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    isGenerateGroupsValid = () => {
        if (this.state.selected_ic !== null) {
            let ic = this.state.all_ics.find(ic => ic.name === this.state.selected_ic)
            let status = ic.operation_status.dedup_detection_status

            if (status === 'InProgress') {
                return false
            } else {
                return true
            }
        }
    }

    renderVersions = () => {
        return (
            <div style = {{width : '100%', height : '100%' }}>
                <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>IRC Report Versions</Typography>
                    {!this.isGenerateGroupsValid() && <Tooltip title="Refresh generate group status" arrow>
                            <IconButton
                                size="small"
                                style={{ color: "#039be5" }}
                                onClick={() => {
                                    this.getIRCICs()
                                    this.getVersions()
                                }}
                            >
                                <Refresh size="small" />
                            </IconButton>
                            </Tooltip>}
                    {!this.state.open_generate_group_params && <Button
                        variant = 'contained'
                        size = 'small'
                        color = 'primary'
                        disabled = {!this.isGenerateGroupsValid()}
                        onClick = {() => this.setState({...this.state, open_generate_group_params: !this.state.open_generate_group_params})}
                    >
                        {this.isGenerateGroupsValid() ? 'Generate Groups' : 'In Progress'}
                    </Button>}
                </Paper>
                {
                    (this.state.generating_groups || this.state.loading_versions) && <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <CircularProgress variant = 'indeterminate' color = 'primary'/>
                    </div>
                }
                { !this.state.generating_groups && !this.state.loading_versions && <Collapse in = {this.state.open_generate_group_params}>
                    <Paper square elevation = {0} style = {{width : '100%'}}>
                        {this.state.versions && <div style = {{width : '100%', height : '50px', padding : '10px', borderBottom: '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography variant = 'caption' color = 'secondary'>Generating Groups will clear all previous versions</Typography>
                        </div>}
                        <div style = {{width : '100%', height : '50px',borderBottom: '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px'}}>
                            <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Parameters to generate groups</Typography>
                            <IconButton size = 'small' color = 'secondary' onClick = {() => this.setState({...this.state, 
                                open_generate_group_params : false,
                                global_schema_IU : null,
                                clustering_threshold : 0,
                                value_weight : 0
                            })}>
                                <Clear fontSize = 'inherit'/>
                            </IconButton>
                        </div>
                        <div style = {{width : '100%', padding : '10px', display : 'flex', flexFirection : 'row', alignItems: 'center', alignContent : 'flex-start'}}>
                            {/* <div style = {{width : '33%', padding : '10px', marginTop: '10px'}}>
                                <div style = {{width : '100%', height : '75px'}}>
                                    <FormControl fullWidth>
                                        <InputLabel>Global Field IU</InputLabel>
                                        <Select
                                            value={this.state.global_schema_IU}
                                            onChange={(event) => this.setState({...this.state, global_schema_IU : event.target.value})}
                                        >
                                            {this.state.models.find(model => model.name === this.state.selected_ic).information_units.map(iu => {
                                                return (
                                                    <MenuItem value = {iu.name}>{iu.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style = {{width : '100%', height : '50px'}}>
                                    <Typography variant = 'caption' color = 'textSecondary'>Select the IU containing global fields.</Typography>
                                </div>
                            </div> */}
                            <div style = {{width : '33%', padding : '10px', marginTop: '10px'}}>
                                <div style = {{width : '100%', height : '75px'}}>
                                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'body2'>Clustering Threshold</Typography>
                                        <Typography variant = 'subtitle2' color = 'primary'>{this.state.clustering_threshold}</Typography>
                                    </div>
                                    <Slider 
                                        value = {this.state.clustering_threshold} 
                                        onChange = {(event, newValue) => this.setState({...this.state, clustering_threshold: newValue})} 
                                        style = {{width : '100%', marginRight : '10px'}}
                                        valueLabelDisplay="auto"
                                        min = {0}
                                        max = {1}
                                        step = {0.01}
                                    />
                                </div>
                                <div style = {{width : '100%', height : '50px'}}>
                                    <Typography variant = 'caption' color = 'textSecondary'>Controls the quality of grouping. Higher value enforces grouping of highly similar fields and vice a versa.</Typography>
                                </div>
                            </div>
                            {/* <div style = {{width : '33%', padding : '10px', marginTop: '10px'}}>
                                <div style = {{width : '100%', height : '75px'}}>
                                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'body2'>Value Weight</Typography>
                                        <Typography variant = 'subtitle2' color = 'primary'>{this.state.value_weight}</Typography>
                                    </div>
                                    <Slider 
                                        value = {this.state.value_weight} 
                                        onChange = {(event, newValue) => this.setState({...this.state, value_weight: newValue})} 
                                        style = {{width : '100%', marginRight : '10px'}}
                                        valueLabelDisplay="auto"
                                        min = {0}
                                        max = {1}
                                        step = {0.01}
                                    />
                                </div>
                                <div style = {{width : '100%', height : '50px'}}>
                                    <Typography variant = 'caption' color = 'textSecondary'>The weight given for value-based similarity in computing similarity for a pair of fields.</Typography>
                                </div>
                            </div> */}
                        </div>
                        {/* <div style = {{width : '100%', display : 'flex', flexDirection : 'row', padding : '10px', marginTop: '10px'}}>
                            <div style = {{width : '33%'}}>
                                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                    <Typography style = {{flexGrow : 1}} variant = 'body2'>Historical Mapping</Typography>
                                </div>
                                <TextField
                                    placeholder = "Historical Mappings"
                                    helperText = "Path the historical map file"
                                    fullWidth
                                    value = {this.state.historical_mappings}
                                    onChange = {(event) => this.setState({...this.state, historical_mappings : event.target.value === "" ? null : event.target.value})}
                                />
                            </div>
                            <div style = {{width : '33%', paddingLeft : '10px'}}>
                                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                    <Typography style = {{flexGrow : 1}} variant = 'body2'>Use Conflict Scores</Typography>
                                    <Switch
                                        color = 'primary'
                                        checked = {this.state.use_conflict_scores}
                                        onChange={(event) => this.setState({...this.state, use_conflict_scores : event.target.checked})}
                                    />
                                </div>
                            </div>
                        </div> */}
                        <div style = {{width : '100%', height : '50px', padding : '10px', marginTop : '10px', borderTop : '1px solid rgba(0,0,0,0.12)', borderBottom: '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center'}}>
                            <Button
                                variant = 'contained'
                                size = 'small'
                                color = 'primary'
                                onClick = {() => this.generateGroups()}
                            >
                                Generate Groups
                            </Button>
                            <Typography style = {{flexGrow : 1}} variant = 'capition' color = 'secondary'>{this.state.generating_groups_error_message}</Typography>
                        </div>
                    </Paper>
                </Collapse>}
                {!this.state.loading_versions && this.state.versions !== null && <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Version</TableCell>
                                    <TableCell>User ID</TableCell>
                                    <TableCell>Source Version</TableCell>
                                    <TableCell>Created On</TableCell>
                                    <TableCell>Completed On</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align = 'center'>Actions</TableCell>
                                    <TableCell>Consolidation</TableCell>
                                    <TableCell>Export Report</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.versions.map(ver => {
                                    return (
                                        <TableRow>
                                            <TableCell>{ver.version}</TableCell>
                                            <TableCell>{ver.uid}</TableCell>
                                            <TableCell>{ver.source_version}</TableCell>
                                            <TableCell>{format(new Date(ver.begin_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx")}</TableCell>
                                            <TableCell>{ver.end_timestamp !== null ? format(new Date(ver.end_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx") : null}</TableCell>
                                            <TableCell>{ver.status}</TableCell>
                                            <TableCell>{ver.status === 'Complete' ? 
                                                <Fragment>
                                                    <Button
                                                        size = 'small'
                                                        color = 'primary'
                                                        onClick = {() => this.createNewVersion(ver.version)}
                                                    >New Version</Button>
                                                    <Button
                                                        size = 'small'
                                                        color = 'secondary'
                                                        disabled = {ver.consolidation_status === "Pending" || ver.consolidation_status === "Complete"}
                                                        onClick = {() => this.consolidate(ver.version)}
                                                    >Consolidate</Button>
                                                </Fragment> :
                                                <Fragment>
                                                    <Button
                                                        size = 'small'
                                                        color = 'primary'
                                                        onClick = {() => this.reviewVersion(ver.version)}
                                                    >Review</Button>
                                                    <Button
                                                        size = 'small'
                                                        color = 'secondary'
                                                        onClick = {() => this.completeReview(this.state.selected_ic, ver.version)}
                                                    >
                                                        Complete
                                                    </Button>
                                                </Fragment>
                                            }</TableCell>
                                            <TableCell>
                                                {ver.consolidation_status !== 'Complete' ? 
                                                <>
                                                    <Typography variant = 'caption'>{ver.consolidation_status}</Typography>
                                                </> :
                                                <>
                                                    <Typography variant = 'subtitle2'>{ver.consolidation_status}</Typography>
                                                    <Typography variant = 'caption'>{format(new Date(ver.consolidation_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx")}</Typography>
                                                </>}
                                            </TableCell>
                                            <TableCell>
                                                <Button 
                                                    disabled = {ver.status === 'Complete' ? false : true} 
                                                    size = 'small' 
                                                    variant="contained" 
                                                    color="primary"
                                                    onClick = {() => {
                                                        Actions("http_request", {
                                                            url: "/sainapse/irc/report_info",
                                                            method : "post",
                                                            data : {
                                                                ic_name : this.state.selected_ic,
                                                                version : ver.version,
                                                                step_tag : this.state.step_tag
                                                            }
                                                        }).then(res => {
                                                            this.setState({...this.state, open_export_request_dialog : true, export_version : ver.version, export_version_groups : res.data.result.Result.group_ids.length})
                                                        })
                                                    }}
                                                >
                                                    Export
                                                </Button>
                                                {/* <ButtonGroup disabled = {ver.status === 'Complete' ? false : true} size = 'small' variant="contained" color="primary">
                                                    <Button onClick = {() => this.initiateReportExport(ver.version, 'html')}>HTML</Button>
                                                    <Button onClick = {() => this.initiateReportExport(ver.version, 'csv')}>CSV</Button>
                                                    <Button onClick = {() => this.initiateReportExport(ver.version, 'excel')}>Excel</Button>
                                                </ButtonGroup> */}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>}
            </div>
        )
    }

    completeReview = (ic_name, version) => {
        Actions('http_request', {
            url : "/sainapse/irc/review_complete",
            method : "post",
            data : {
                ic_name : ic_name,
                version : version,
                step_tag : this.state.step_tag
            }
        }).then(res=> {
            this.getVersions()
        })
    }

    createNewVersion = (version) => {
        Actions('http_request', {
            url : "/sainapse/irc/review_start",
            method : "post",
            data : {
                ic_name : this.state.selected_ic,
                source_version : version,
                step_tag : this.state.step_tag
            }
        }).then(res => {
            this.getVersions()
        })
    }

    consolidate = (version) => {
        Actions('http_request', {
            url : "/sainapse/irc/consolidate",
            method : "post",
            data : {
                // drop_merged : true,
                ic_name: this.state.selected_ic,
                version : version,
                step_tag : this.state.step_tag
            }
        }).then(res => {
            this.getVersions()
        })
    }

    initiateExportReport = () => {
        this.setState({...this.state, initiating_export_request : true, export_request_success : false, export_request_error : false}, () => {
            if (this.state.export_version_type === 'range') {
                Actions('http_request', {
                    url : this.state.drl_url + "/drl/irc/report_by_range",
                    method : 'post',
                    data : {
                        ic_name : this.state.selected_ic,
                        version : this.state.export_version,
                        ranges : this.state.export_ranges,
                        format : this.state.export_version_format,
                        step_tag : this.state.step_tag
                    }
                }).then(res => {
                    this.setState({...this.state, initiating_export_request : false, export_request_success : true, export_request_error : false})
                }).catch(err => {
                    this.setState({...this.state, initiating_export_request : false, export_request_success : false, export_request_error : true})
                })
            } else if (this.state.export_version_type === 'subset') {
                Actions('http_request', {
                    url : this.state.drl_url + "/drl/irc/report_by_subset",
                    method : 'post',
                    data : {
                        ic_name : this.state.selected_ic,
                        version : this.state.export_version,
                        subset_size : this.state.export_subset_size,
                        format : this.state.export_version_format,
                        step_tag : this.state.step_tag
                    }
                }).then(res => {
                    this.setState({...this.state, initiating_export_request : false, export_request_success : true, export_request_error : false})
                }).catch(err => {
                    this.setState({...this.state, initiating_export_request : false, export_request_success : false, export_request_error : true})
                })
            }
        })
    }

    downloadReport = (file_link) => {
        Actions('http_request', {
            url : this.state.drl_url + "/" + file_link,
            method : 'get',
            responseType : 'arraybuffer'
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_link)
            document.body.appendChild(link);
            link.click();
        })
    }

    reviewVersion = (version) => {
        this.setState({...this.state, report_version : version, show_report : true })
    }

    generateGroups = () => {
        this.setState({...this.state, generating_groups : true, generating_groups_error : false, generating_groups_error_message : ""}, () => {
            Actions("http_request", {
                url : "/sainapse/irc/generate_groups",
                method : "post",
                data : {
                    // global_schema_IU : this.state.global_schema_IU,
                    clustering_threshold : this.state.clustering_threshold,
                    ic_name : this.state.selected_ic,
                    use_conflict_scores : this.state.use_conflict_scores,
                    historical_mappings : this.state.historical_mappings,
                    value_weight: this.state.value_weight,
                    step_tag : this.state.step_tag
                }
            }).then(res => {
                this.setState({...this.state, generating_groups : false, open_generate_group_params: false, clustering_threshold : 0, value_weight : 0, versions : null}, () => this.getIRCICs())
            }).catch(err => {
                this.setState({...this.state, generating_groups : false, generating_groups_error : true, generating_groups_error_message : err.response.data.message})
            })
        })
    }

    renderExportReport = () => {
        return (
            <Dialog
                open = {this.state.open_export_request_dialog}
                onClose = {() => this.setState({...this.state, open_export_request_dialog : false, export_request_success : false, export_request_error : false, range_index_error : false})}
            >
                <DialogTitle>Initiating Export Request</DialogTitle>
                <DialogContent style = {{ height : '50vh'}}>
                    <div style = {{display : 'flex', flexDirection : 'column'}}>
                        <Typography>{'You are exporting the report for version : ' + this.state.export_version + '. This version has ' + this.state.export_version_groups + ' groups.'}</Typography>
                        <div style = {{marginTop : '20px', display : 'flex', direction : 'row'}}>
                            <FormControl style = {{flexGrow : 1, marginRight : '10px'}} size='small' component="fieldset">
                                <FormLabel component="legend">Select Group Selection Method </FormLabel>
                                <RadioGroup aria-label="type" name="export-type" value={this.state.export_version_type} onChange={(event) => this.setState({...this.state, export_version_type : event.target.value})}>
                                    <FormControlLabel value="range" control={<Radio />} label="Range" />
                                    <FormControlLabel value="subset" control={<Radio />} label="Random Sample" />
                                </RadioGroup>
                            </FormControl>
                            <FormControl style = {{flexGrow : 1}} size='small' component="fieldset">
                                <FormLabel component="legend">Select Report Format</FormLabel>
                                <RadioGroup aria-label="type" name="export-format" value={this.state.export_version_format} onChange={(event) => this.setState({...this.state, export_version_format : event.target.value})}>
                                    <FormControlLabel value="html" control={<Radio />} label="HTML" />
                                    <FormControlLabel value="csv" control={<Radio />} label="CSV" />
                                    <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div style = {{marginTop : '20px'}}>
                            {this.renderExportSettings()}
                        </div>
                        <div style = {{marginTop : '25px', display : 'flex', flexDirection : 'column', alignItems : 'center', justifyContent : 'center'}}>
                            {this.state.initiating_export_request && <CircularProgress variant = 'indeterminate'/>}
                            {this.state.export_request_success && <CheckCircleOutline fontSize = 'large' color='primary'/>}
                            {this.state.export_request_error && <ErrorOutline fontSize = 'large' color = 'error'/>}
                            {this.state.initiating_export_request && <Typography variant = 'body2' align='center'>Initiating Export Request...</Typography>}
                            {this.state.export_request_success && <Typography variant = 'body2' align='center'>Export Requested successfully. Please vsit the exports tab for status.</Typography>}
                            {this.state.export_request_error && <Typography variant = 'body2' align='center' color='secondary'>Error initating export request!</Typography>}
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick = {() => this.setState({...this.state, 
                            open_export_request_dialog : false, 
                            export_request_success : false, 
                            export_request_error : false,
                            export_version : 0,
                            export_version_groups : 0,
                            export_version_type : 'range',
                            export_version_format : 'html',
                            export_ranges : [],
                            export_subset_size : 0,
                            range_start_index : 0,
                            range_end_index : 0,
                            range_index_error : false,
                        })}
                    >Close</Button>
                    <Button
                        color = 'primary'
                        onClick = {this.initiateExportReport}
                    >Export</Button>
                </DialogActions>
            </Dialog>
        )
    }

    renderExportSettings = () => {
        if (this.state.export_version_type === 'range') {
            return (
                <Fragment>
                    <Typography>Add Ranges</Typography>
                    <div style = {{marginTop: '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                        <TextField
                            size='small'
                            id = 'range_start_index'
                            label="Start Index"
                            type='number'
                            defaultValue={this.state.range_start_index}
                            value = {this.state.range_start_index}
                            onChange={(event) => this.setState({...this.state, range_start_index : event.target.value})}
                        />
                        <Typography style = {{marginLeft : '20px', marginRight : '20px'}}>-</Typography>
                        <TextField
                            size='small'
                            id = 'range_end_index'
                            label="End Index"
                            type='number'
                            defaultValue={this.state.range_end_index}
                            value = {this.state.range_end_index}
                            onChange={(event) => this.setState({...this.state, range_end_index : event.target.value})}
                        />
                        <Button
                            style = {{marginLeft : '20px'}}
                            variant = 'contained'
                            color = 'primary'
                            onClick = {() => {
                                let range = {
                                    start_index : this.state.range_start_index,
                                    end_index : this.state.range_end_index
                                }
                                if( range.start_index >= 0 && range.end_index >= 0 && range.start_index <= range.end_index) {
                                    let ranges = [...this.state.export_ranges]
                                    ranges.push(range)
                                    this.setState({...this.state, range_start_index : 0, range_end_index : 0, export_ranges : ranges, range_index_error : false}, () => this.mergeRanges())
                                } else {
                                    this.setState({...this.state, range_start_index : 0, range_end_index : 0, range_index_error : true}, () => console.log('IRC Export Ranges :: ', this.state.export_ranges))
                                }    
                            }}
                        >Add</Button>
                    </div>
                    {this.state.range_index_error && <Typography color='secondary' variant='body2'>start_index and end_index must be positive and start_index must be less than or equal to end_index</Typography>}
                    {this.state.export_ranges.map(range => {
                        return (
                            <Chip style = {{margin : '5px'}} size = 'small' label = {range.start_index + " - " + range.end_index}/>
                        )
                    })}
                </Fragment>
            )
        } else if (this.state.export_version_type === 'subset') {
            return (
                <Fragment>
                    <div style={{ display : 'flex', flexDirection : 'column'}}>
                        <Typography>Sample Size</Typography>
                        <div style = {{marginTop: '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                            <TextField
                                size='small'
                                id = 'export-subset-size'
                                label="Subset size"
                                type='number'
                                defaultValue={this.state.export_subset_size}
                                value = {this.state.export_subset_size}
                                onChange={(event) => {
                                    if(event.target.value > 0) {
                                        this.setState({...this.state, export_subset_size : event.target.value, range_index_error : false}) 
                                    }
                                    else {
                                        this.setState({...this.state, range_index_error : true})
                                    }
                                }}
                            />
                        </div>
                        {this.state.range_index_error && <Typography color='secondary' variant='body2' style={{ marginTop: '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>subset size should be greater than 0</Typography>}
                    </div>
                </Fragment>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderExportReport()}
                {this.state.show_report ? this.renderReport() : this.renderIRCs()}
            </ThemeProvider>
        )
    }
}
 
export default withStyles(styles)(IRC);